// ------------------------------------------------------------------
// Analytics ID
// ------------------------------------------------------------------
//
var analyticsId = 'UA-15325774-11';
var pageName = 'UA-15325774-11';

// ------------------------------------------------------------------
// ACCOUNT APP JS
// ------------------------------------------------------------------
//

var account = {};

account.el = {
	inputs: {
		'password': document.getElementById('password'),
		'passwordConfirm': document.getElementById('passwordConfirm'),
		'mobilePhone': document.getElementById('mobilePhone'),
		'mailingPhoneNumber': document.getElementById('mailingPhoneNumber'),
		'mailingFaxNumber': document.getElementById('mailingFaxNumber'),
		'billingPhoneNumber': document.getElementById('billingPhoneNumber'),
		'billingFaxNumber': document.getElementById('billingFaxNumber')
	}
};

// ------------------------------------------------------------------
// Masking
// ------------------------------------------------------------------
//

account.phoneMask = function(e) {
	var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
	e.target.value = !x[2] ? x[1] : '' + x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
};

if (stat.isPage('Create Your Utah.gov Account') || stat.isPage('My Account')) {
	account.el.inputs.mobilePhone.addEventListener('input', account.phoneMask, false);
}


// ------------------------------------------------------------------
// MY ACCOUNT
// ------------------------------------------------------------------
//

if (stat.isPage('My Account')) {
	var pwfieldset = $('#passwordUpdate'),
		pwchgbtn = $('#updatePasswordLink');

	// hide pw fieldset on load
	pwfieldset.addClass('hidden');
	// show pw fieldset on click
	pwchgbtn.on('click', function() {
		if (pwfieldset.hasClass('hidden')){
			pwfieldset.removeClass('hidden');
			pwchgbtn.addClass('hidden');
			//$(this).text("Update my Password");
		} else {
			pwfieldset.addClass('hidden');
			pwchgbtn.removeClass('hidden');
		}
	});
}

// ------------------------------------------------------------------
// Password Comparisons / Helpers
// ------------------------------------------------------------------
//

if (stat.isPage('Create Your Utah.gov Account') || stat.isPage('My Account')) {

	var pwMessage = stat.build.elementWithAttributes('span', {}, null);
	var pwConfMessage = stat.build.elementWithAttributes('span', {}, null);
	var pwContainer = document.querySelector('.password-field');
	var pwconfContainer = document.querySelector('.passwordconfirm-field');
	var passwordUpdateContainer = document.getElementById('passwordUpdate');
	// Errors Check
	var pwContainerError = pwContainer.querySelector('.pwerror');
	var pwconfContainerError = pwconfContainer.querySelector('.pwerror');

	if (!pwContainerError) {
		pwContainer.appendChild(pwMessage);	
	}
	else if (passwordUpdateContainer && pwContainerError) {
		passwordUpdateContainer.classList.remove('hidden');
	}
	if (!pwconfContainerError) {
		pwconfContainer.appendChild(pwConfMessage);
	}
	else if (passwordUpdateContainer && pwconfContainerError) {
		passwordUpdateContainer.classList.remove('hidden');
	}

	account.checkpw = function(e) {
		var len = e.target.value.length;
		pwMessage.innerHTML = '';

		if (len >= 8) {
			pwMessage.className = 'success';
			pwMessage.innerHTML = '&#10004; At least 8 characters';
		}
		else if (len < 8) {
			pwMessage.className = 'error';
			pwMessage.innerText = 'Must be at least 8 characters';
		}
	};

	account.comparepw = function(e) {
		var pwVal = account.el.inputs.password.value;
		var pwconfVal = account.el.inputs.passwordConfirm.value;
		var pwconfLen = account.el.inputs.passwordConfirm.value.length;
		pwConfMessage.innerHTML = '';

		if (pwVal === pwconfVal && pwconfLen >= 1) {
			pwConfMessage.className = 'success';
			pwConfMessage.innerHTML = '&#10004; Passwords match';
		}
		else if (pwconfLen >= 1) {
			pwConfMessage.className = 'error';
			pwConfMessage.innerHTML = 'Passwords do not match';
		}
		else {
			pwConfMessage.innerHTML = '';
		}
	};

	account.el.inputs.password.addEventListener('blur', account.checkpw, false);
	account.el.inputs.password.addEventListener('keyup', account.checkpw, false);
	account.el.inputs.passwordConfirm.addEventListener('blur', account.comparepw, false);
	account.el.inputs.passwordConfirm.addEventListener('keyup', account.comparepw, false);

}

// ------------------------------------------------------------------
// MESSAGE TIMEOUT
// Triggered by class .timeout
// Delay is 20 seconds
// ------------------------------------------------------------------
//

$('.message.timeout').addClass('fadeout').delay(20000).queue(function (hide) {
	$(this).addClass('hidden');
	hide();
});

// Confirm Page
if (stat.isPage('Confirm')) {
	var feeUnderstand = $('#feeUnderstand'),
		feeUnderstandMessage = $('.message.feeUnderstand'),
		confirmButton = $('.confirmButton');

	feeUnderstand.click(function(event) {
		if (event.currentTarget.checked) {
			confirmButton.removeClass('hidden');
			feeUnderstandMessage.removeClass('alert').addClass('success');
		} else if (!event.currentTarget.checked) {
			confirmButton.addClass('hidden');
			feeUnderstandMessage.removeClass('success').addClass('alert');
		}
	});
} // stat.isPage('Confirm')
// ------------------------------------------------------------------
// SUBSCRIBER CUSTOMER INFO
// ------------------------------------------------------------------
//

if (stat.isPage('Customer Information')) {	
	
	account.el.inputs.mobilePhone.mailingPhoneNumber.addEventListener('input', account.phoneMask, false);
	account.el.inputs.mobilePhone.mailingFaxNumber.addEventListener('input', account.phoneMask, false);
	account.el.inputs.mobilePhone.billingPhoneNumber.addEventListener('input', account.phoneMask, false);
	account.el.inputs.mobilePhone.billingFaxNumber.addEventListener('input', account.phoneMask, false);

	// --------------------------------------------------------------
	// MAILING SAME AS BILLING
	// --------------------------------------------------------------
	//

	var sameAddress = document.getElementById('sameAddress');
  	sameAddress.onclick = function(e) { mailingToBilling(this.form, e.target.checked); };

	var mailingToBilling = function(form, act) {
		if (act) {
			form.billingOrganizationName.value = form.mailingOrganizationName.value;
			form.billingFirstName.value = form.mailingFirstName.value;
			form.billingLastName.value = form.mailingLastName.value;
			form.billingEmail.value = form.mailingEmail.value;
			form.billingCountry.value = form.mailingCountry.value;
			form.billingAddress.value = form.mailingAddress.value;
			form.billingCity.value = form.mailingCity.value;
			form.billingState.value = form.mailingState.value;
			form.billingPostalCode.value = form.mailingPostalCode.value;
			form.billingPhoneNumber.value = form.mailingPhoneNumber.value;
			form.billingFaxNumber.value = form.mailingFaxNumber.value;	
		} 
		else if (!act) {
			form.billingOrganizationName.value = '';
			form.billingFirstName.value = '';
			form.billingLastName.value = '';
			form.billingEmail.value = '';
			form.billingCountry.value = '';
			form.billingAddress.value = '';
			form.billingCity.value = '';
			form.billingState.value = '';
			form.billingPostalCode.value = '';
			form.billingPhoneNumber.value = '';
			form.billingFaxNumber.value = '';
		}
	} // mailingToBilling

} // stat.isPage('Customer Information')
// ------------------------------------------------------------------
// Manage Access FUNCTIONS
// ------------------------------------------------------------------
//

if (stat.isPage('Manage Access')) {

	// --------------------------------------------------------------
	// USER ROLES ACCORDIAN LIST
	// --------------------------------------------------------------
	//

	var rolesAllitems = $('.account-roles li'),
		rolesChildren = $('.hasChild ul'),
		rolesFilter = $('#filterRoles'),
		rolesToggles = $('.toggle'),
		clearFilter = $('.clearfilter');

	// hide child containers on load:
	rolesChildren.addClass('hidden');
	clearFilter.addClass('hidden');

	$('.account-roles').on('click', '.toggle', function(e){
		var parent = $(this).closest('li.hasChild');
		var target = parent.children('ul');
		if ($(this).hasClass('fa-caret-left')) {
			target.removeClass('hidden');
			parent.addClass('open');
			$(this).removeClass('fa-caret-left').addClass('fa-caret-down');
		}
		else if ($(this).hasClass('fa-caret-down')) {
			target.addClass('hidden');
			parent.removeClass('open');
			$(this).removeClass('fa-caret-down').addClass('fa-caret-left');
		}
	});

	var rolesReset = function() {
		rolesChildren.addClass('hidden');
		clearFilter.addClass('hidden');
		rolesAllitems.removeClass('hidden');
		rolesFilter.val('');
		rolesToggles.removeClass('fa-caret-down').addClass('fa-caret-left');
	}

	// --------------------------------------------------------------
	// USER ROLES QUICK FILTER
	// --------------------------------------------------------------
	//


	rolesFilter.keyup(function() {
		var filteritem = $('ul.account-roles').children('li'),
			filtertexts = filteritem.children('.title'),
			val = $.trim($(this).val()).replace(/ +/g, ' ').toLowerCase();

		if (val.length >= 1) {
			// Do Filter
			var filterresults = filteritem.addClass('hidden').filter(function() {
				var text = $(this).text().replace(/\s+/g, ' ').toLowerCase();
				return ~text.indexOf(val);
			});

			clearFilter.removeClass('hidden');
			//console.log(filterresults);
			filterresults.removeClass('hidden');
			rolesToggles.removeClass('fa-caret-left').addClass('fa-caret-down');
			rolesChildren.removeClass('hidden');

			if (!$(this).val() ) {
				filterresults.hide();
			}
		}
		else {
			// Show All
			filteritem.removeClass('hidden');
			rolesToggles.removeClass('fa-caret-down').addClass('fa-caret-left');
			rolesChildren.addClass('hidden');
			clearFilter.addClass('hidden');
		}
	});

	$('body').on('click', '.clearfilter', function(event) {
		clearFilter.addClass('hidden');
		rolesReset();
	});

} // stat.isPage('Manage Access')
if (stat.isPage('Payment Information')) {
	
	// --------------------------------------------------------------
	// PAYMENT OPTIONS SELECTION (copied from in page js)
	// --------------------------------------------------------------
	//

	function showCC() {          
	   $('#creditcard_fields').show();    
	   $('#autocheck_fields').hide();
	}
	function showEC() {       
	   $('#creditcard_fields').hide();    
	   $('#autocheck_fields').show();
	}
	function showEmail() {       
	   $('#creditcard_fields').hide();    
	   $('#autocheck_fields').hide();
	}
	
	$('#paymentType_creditcard').change(function() {
		showCC();
	});
	$('#editcard').click(function() {
		showCC();
	});
	
	$('#paymentType_autocheck').change(function() {
		showEC();
	});
	$('#editbank').click(function() {
		showEC();
	});
	
	$('#paymentType_email').change(function() {
		showEmail();
	});

} // stat.isPage('Payment Information')
// ------------------------------------------------------------------
// Network Registration Agreement
// ------------------------------------------------------------------
//

if (stat.isPage('Registration Agreement')) {
	var termsAgreement = $('#termsAgreement'),
		termsAgreementMessage = $('.message.termsAgreement'),
		feeAgreement = $('#feeAgreement'),
		feeAgreementMessage = $('.message.feeAgreement'),
		continueSubscription = $('.continueSubscription');

	termsAgreement.click(function(event) {
		if (event.currentTarget.checked) {
			feeAgreementMessage.removeClass('hidden');
			termsAgreementMessage.removeClass('alert').addClass('success');
		} else if (!event.currentTarget.checked) {
			feeAgreementMessage.addClass('hidden');
			termsAgreementMessage.removeClass('success').addClass('alert');
			continueSubscription.addClass('hidden');
			feeAgreement.attr('checked', false);
			feeAgreementMessage.removeClass('success').addClass('alert');
		}
	});
	feeAgreement.click(function(event) {
		if (event.currentTarget.checked) {
			continueSubscription.removeClass('hidden');
			feeAgreementMessage.removeClass('alert').addClass('success');
		} else if (!event.currentTarget.checked) {
			continueSubscription.addClass('hidden');
			feeAgreementMessage.removeClass('success').addClass('alert');
		}
	});
} // stat.isPage('Registration Agreement')